import type { RouteRecordRaw } from 'vue-router';

export const attendanceRoutes: RouteRecordRaw = {
    path: 'attendance',
    components: {
        default: () => import('@/layouts/modules/attendance/AttendanceLayout.vue'),
        sidebar: () => import('@/layouts/modules/attendance/AttendanceAside.vue')
    },
    children: [
        {
            path: 'statuses',
            name: 'globalAttendanceStatuses',
            component: () => import('@/views/modules/attendance/AttendanceStatusView.vue'),
        },
        {
            path: 'presence-sessions',
            name: 'globalPresenceSessions',
            component: () => import('@/views/modules/attendance/PresenceSessionsView.vue'),
        },
        
        // School-specific routes
        {
            path: 'school',
            children: [
                {
                    path: 'attendance-statuses',
                    name: 'attendanceStatuses',
                    component: () => import('@/views/modules/attendance/SchoolAttendanceStatusView.vue'),
                    children: [
                        {
                            path: ':schoolAttendanceStatusesId/update',
                            name: 'updateSchoolAttendanceStatuses',
                            component: () => import('@/components/modules/attendance/school-attendance-status/SchoolAttendanceStatusEditModal.vue'),
                            props: route => ({
                                schoolId: route.query.schoolId ? Number(route.query.schoolId) : null
                            }),
                        }
                    ],
                },
                {
                    path: 'presence-sessions',
                    name: 'schoolPresenceSessions',
                    component: () => import('@/views/modules/attendance/SchoolPresenceSessionView.vue'),
                }
            ]
        }
    ]
};